export enum DexNamesEnum {
    quickswap = 'quickswap',
    uniswap = 'uniswap',
    pancakeswap = 'pancakeswap',
    joeswap = 'joeswap',
    dmmswap = 'dmmswap',
    spookyswap = 'spookyswap',
    babyswap = 'babyswap',
    sushiswap_eth = 'sushiswap_eth',
    sushiswap_bsc = 'sushiswap_bsc',
    sushiswap_pol = 'sushiswap_pol',
    sushiswap_heco = 'sushiswap_heco',
    sushiswap_harmony = 'sushiswap_harmony',
    biswap = 'biswap',
    mdexswap = 'mdexswap',
    'bsc-testswap' = 'bsc-testswap',
    blhswap = 'blhswap',
    pangolinswap = 'pangolinswap',
    apeswap = 'apeswap',
    'knightswap' = 'knightswap',
    // 'goerli-testswap' = 'goerli-testswap',
    uniswap_v3 = 'uniswap_v3',
    uniswap_v3_pol = 'uniswap_v3_pol',
    uniswap_v3_opt = 'uniswap_v3_opt',
    uniswap_v3_arb = 'uniswap_v3_arb',
    uniswap_v3_celo = 'uniswap_v3_celo',
    uniswap_v3_base = 'uniswap_v3_base',
    uniswap_v3_mantle = 'uniswap_v3_mantle',
    oreoswap = 'oreoswap',
    zyberswap = 'zyberswap',
    thena = 'thena',
    alienswap = 'alienswap',
    camelot = 'camelot',
    zyberswap_v3 = 'zyberswap_v3',
    pancakeswap_v3 = 'pancakeswap_v3',
    shibaswap = 'shibaswap',
    'uniswap_v3_bsc' = 'uniswap_v3_bsc',
    quickswap_v3 = 'quickswap_v3',
    dexSwap = 'dexSwap',
    'joeswap_v2_ava' = 'joeswap_v2_ava',
    'joeswap_v2_arb' = 'joeswap_v2_arb',
    pancakeswap_zksync = 'pancakeswap_zksync',
    pancakeswap_v3_zksync = 'pancakeswap_v3_zksync',
    synthswap = 'synthswap',
    synthswap_v3 = 'synthswap_v3',
    camelot_v3 = 'camelot_v3',
    sushiswap_arb = 'sushiswap_arb',
    sushiswap_v3_arb = 'sushiswap_v3_arb',
    balancer_eth = 'balancer_eth',
    balancer_pol = 'balancer_pol',
    raydium = 'raydium',
    raydium_v3 = 'raydium_v3',
    sushiswap_base = 'sushiswap_base',
    thruster_v2 = 'thruster_v2',
    thruster_v3 = 'thruster_v3',
    cyberblast_v2 = 'cyberblast_v2',
    cyberblast_v3 = 'cyberblast_v3',
    uniswap_base = 'uniswap_base',
    alien_base = 'alien_base',
    alien_v3_base = 'alien_v3_base',
    // saucerswap_hedera = 'saucerswap_hedera',
    // saucerswap_v3_hedera = 'saucerswap_v3_hedera',
    balancer_arb = 'balancer_arb',
    aerodrome_base = 'aerodrome_base',
    dedust = 'dedust',
    sushiswap_haqq = 'sushiswap_haqq',
    sushiswap_v3_haqq = 'sushiswap_v3_haqq',
    curve_eth = 'curve_eth',
    curve_pol = 'curve_pol',
    vtru = 'vtru',
    taffy = 'taffy',
    meteora = 'meteora',
    hypecoin = 'hypecoin',
    sunswap = 'sunswap',
    stonfi = 'stonfi',
    sunpump = 'sunpump',
    kim = 'kim',
    turbos_sui = 'turbos_sui',
    cetus_sui = 'cetus_sui',
    kaiaswap = 'kaiaswap',
    klayswap_v2 = 'klayswap_v2',
    unitsswop = 'unitsswop',
    meteora_dlmm = 'meteora_dlmm',
    stonfi_v2 = 'stonfi_v2',
    wagmi = 'wagmi',
    pumpfun = 'pumpfun',
    xrpl_dex = "xrpl_dex",
    kyo_soneium = "kyo_soneium",
    kyo_v3_soneium = "kyo_v3_soneium",
    velodrome_soneium = 'velodrome_soneium',
    beraswap = 'beraswap',
    sonic_shadow_dex = 'sonic_shadow_dex',
    sonic_v3_shadow_dex = 'sonic_v3_shadow_dex',
    orca = 'orca',
    pumpswap = 'pumpswap',
    velodrome_v2_soneium = 'velodrome_v2_soneium',
    uniswap_v4 = 'uniswap_v4',
    uniswap_v4_pol = 'uniswap_v4_pol',
    cooldex = 'cooldex',
    something_cool = 'something_cool',
    raydium_launchlab = 'raydium_launchlab',
    raydium_v2_dev = 'raydium_v2_dev',
    flapsh_bsc = 'flapsh_bsc',
    fourmeme_bsc = 'fourmeme_bsc',
    trebleswap = 'trebleswap',
    pancakeswap_arb = 'pancakeswap_arb',
    bluefin_sui = 'bluefin_sui',
    momentum_sui = 'momentum_sui',
    hyperswap_v2 = 'hyperswap_v2',
    hyperswap_v3 = 'hyperswap_v3',
}

export enum ArbitrageDexNames {
    pancakeswapV2 = 'pancakeswapV2',
    pancakeswapV3 = 'pancakeswapV3',
    uniswapV2 = 'uniswapV2',
    uniswapV3 = 'uniswapV3',
    sushiswapV2 = 'sushiswapV2',
    sushiswapV3 = 'sushiswapV3',
}

export enum CoingeckoDexNamesEnum {
    quickswap = 'quickswap',
    uniswap = 'uniswap-v2-ethereum',
    pancakeswap = 'pancakeswap_v2',
    joeswap = 'lfj',

    spookyswap = 'spookyswap',
    babyswap = 'babyswap',
    sushiswap_eth = 'sushiswap',
    sushiswap_bsc = 'sushiswap_bsc',
    sushiswap_pol = 'sushiswap_polygon_pos',

    sushiswap_harmony = 'sushiswap_harmony',
    biswap = 'biswap',
    mdexswap = 'mdex',


    pangolinswap = 'pangolin',
    apeswap = 'apeswap_bsc',
    knightswap = 'knightswap',

    uniswap_v3 = 'uniswap-v3-ethereum',
    uniswap_v3_pol = 'uniswap-v3-polygon',
    uniswap_v3_opt = 'uniswap-v3-optimism',
    uniswap_v3_arb = 'uniswap-v3-arbitrum-one',
    uniswap_v3_celo = 'uniswap-v3-celo',
    uniswap_v3_base = 'uniswap-v3-base',

    oreoswap = 'oreoswap',
    zyberswap = 'zyberswap',


    camelot = 'camelot',

    pancakeswap_v3 = 'pancakeswap-v3-bsc',
    shibaswap = 'shibaswap',
    uniswap_v3_bsc = 'uniswap-v3-bsc',
    quickswap_v3 = 'quickswap-v3',

    joeswap_v2_ava = 'lfj-v2-avalanche',
    joeswap_v2_arb = 'lfj-v2-arbitrum',
    pancakeswap_zksync = 'pancakeswap-v2-zksync',
    pancakeswap_v3_zksync = 'pancakeswap-v3-zksync',
    synthswap = 'synthswap',
    synthswap_v3 = 'synthswap-v3',
    camelot_v3 = 'camelot_v3',
    sushiswap_arb = 'sushiswap_arbitrum',
    sushiswap_v3_arb = 'sushiswap-v3-arbitrum',
    balancer_eth = 'balancer',
    balancer_pol = 'balancer-v2-polygon',
    raydium = 'raydium',

    sushiswap_base = 'sushiswap-v2-base',
    thruster_v2 = 'thruster-v2',
    thruster_v3 = 'thruster-v3',
    cyberblast_v2 = 'cyberblast-v2',
    cyberblast_v3 = 'cyberblast-v3',
    uniswap_base = 'uniswap-v2-base',
    alien_base = 'alien-base',
    alien_v3_base = 'alien-base-v3',


    balancer_arb = 'balancer-v2-arbitrum',
    aerodrome_base = 'aerodrome-base',
    dedust = 'dedust',


    curve_eth = 'curve',
    curve_pol = 'curve_polygon',

    taffy = 'taffy-finance',
    meteora = 'meteora',
    hypecoin = 'hypecoin',
    sunswap = 'sunswap-v2',
    stonfi = 'ston-fi',
    sunpump = 'sun_io',
    kim = 'kim',
    turbos_sui = 'turbos-finance',
    cetus_sui = 'cetus',
    kaiaswap = 'kaiaswap-klaytn',
    klayswap_v2 = 'klayswap',


    stonfi_v2 = 'stonfi-v2',
    wagmi = 'wagmi-kava',


    kyo_soneium = "kyo_finance_v3",
    kyo_v3_soneium = "kyo_finance_v3",
    velodrome_soneium = 'velodrome-finance-slipstream-soneium',
    sonic_shadow_dex = 'shadow-exchange',
    sonic_v3_shadow_dex = 'shadow-exchange',
    orca = 'orca',
    pumpswap = 'pumpswap',
    uniswap_v4 = 'uniswap-v4-ethereum',
    uniswap_v4_pol = 'uniswap-v4-polygon',
    trebleswap = 'treble-v4',
    pancakeswap_arb = 'pancakeswap-v2-arbitrum',
    bluefin_sui = 'bluefin',
    hyperswap_v2 = 'hyperswap-v2',
    hyperswap_v3 = 'hyperswap-v3',
}
